// How long a tooltip that opened itself stays on screen.
export const HINT_DURATION_MS = 4000;

// Its fade-out, for anything that must wait until the bubble is gone.
export const HINT_EXIT_MS = 200;
